export const BOOKING_FEE_DISCLAIMER_FETCHED = 'BOOKING_FEE_DISCLAIMER_FETCHED';
